import React from 'react';
import PropTypes from 'prop-types';

import { Form } from '../../../../components/form';
import AddressSettingsForm from './AddressSettingsForm';

const BrandAddressSettingsForm = ({
  values,
  onSubmit,
  onTextInput,
  onLocationInput,
  canEdit,
  organizationType,
  children
}) => (
  <Form
    key={canEdit}
    onSubmit={onSubmit}
  >
    <AddressSettingsForm
      onSubmit={onSubmit}
      onLocationInput={(e, location) => onLocationInput(e, location, 'billingAddress')}
      onTextInput={(e) => onTextInput(e, 'billingAddress')}
      organizationType={organizationType}
      values={values}
      canEdit={canEdit}
      isBrand
    />

    {children}
  </Form>
);

BrandAddressSettingsForm.propTypes = {
  children: PropTypes.any,
  organizationType: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onLocationInput: PropTypes.func.isRequired,
  onTextInput: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired
};

export default BrandAddressSettingsForm;
